import React from "react";

export default function Home() {
    return (
        <div className="container">
            <div className="home-container">
                <h1>Raytolfas - О НАС</h1>
            </div>

            <div className="content-container">
                <img src="https://i.ibb.co/Y7mLq4nw/2-33.png" alt="alt-img" className="img-contents"></img>
                <h1>ВСЕ О НАС!</h1>
                <p>Наш проект Raytolfas создает Сайты, Приложения, Игры, и тому подобное.</p>
                <p>если хотите поддержать проект то пожертвуйуте тут:</p>
                <div className="div-row">
                    <button onClick={() => window.location.href = "https://ko-fi.com/mixitosik"}>ПОЖЕРТОВАТЬ (Ko-Fi)</button>
                    <button onClick={() => window.location.href = "https://donatello.to/mixitosik"}>ПОЖЕРТОВАТЬ (Donatello)</button>
                </div>
            </div>

            <div className="content-container">
                <p>
                    А также у нас ещё есть другое!
                </p>
                <button onClick={() => window.location.href = "https://docs.raytolfas.com"}>Документация</button>
                <button onClick={() => window.location.href = "https://donate.raytolfas.com"}>Донат проекта</button>
            </div>
        </div>
    );
}
